export default __webpack_public_path__ + "static/media/seen_book_icon.344947c6.svg";